var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.17505 11.3984H14.825",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 19.275H10.55L14.7775 22.2151C15.4045 22.6521 16.25 22.1853 16.25 21.3906V19.275C19.1 19.275 21 17.2885 21 14.3087V8.34912C21 5.36934 19.1 3.38281 16.25 3.38281H6.75C3.9 3.38281 2 5.36934 2 8.34912V14.3087C2 17.2885 3.9 19.275 6.75 19.275Z",
    stroke: "#0D1116",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.a662179e1eebde0a5bbdd67bef80de3b.svg";
export { ForwardRef as ReactComponent };